
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "VolumeSlider",
  props: {
    initialVolume: {
      type: Number,
      required: true,
    },
    onVolumeChange: {
      type: Function,
      required: true,
    },
  },
  setup(props, { emit }) {
    const currentVolume = ref(props.initialVolume);

    const updateVolume = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const volume = parseFloat(target.value);
      currentVolume.value = volume;
      emit("volume-change", volume);
    };

    return {
      currentVolume,
      updateVolume,
    };
  },
});
